export default "__VITE_ASSET__D8uGf$iG__"